// extracted by css-extract-rspack-plugin
export default {"CloseButton":"ZMeqq","HeaderTitleContainer":"IQHD3","backButton":"_3Kai","defaultBackButton":"s054l","icon":"eccgh","title":"MJUOI"};